<template>
  <div class="cbg-auth">
    <div class="cbg-auth__container">
      <a class="cbg-auth__logo" href="javascript:void(0);" @click="closeModal">
        <Svg class-name="cbg-auth__logo-img" icon-id="#logo"/>
      </a>
      <button class="cbg-auth__close" @click="closeModal">
        <Svg class-name="cbg-auth__close-ico" icon-id="#close"/>
      </button>
      <Transition name="fade" mode="out-in">
        <AccountBlock v-if="isAuth"/>
        <AuthBlock v-else-if="!isAuth" />
      </Transition>
    </div>
  </div>
</template>

<script>
import AuthBlock from "@/components/parts/auth/AuthBlock.vue";
import Svg from "@/components/global/Svg.vue";
import AccountBlock from "@/components/parts/account/AccountBlock.vue";
import {ContextStateSymbol, ContextUpdateSymbol} from "@/components/global/Context.vue";
import {sendRequests} from "@/mixins/sendRequests";
export default {
  name: 'ModalWrapper',
  components: {
    AccountBlock,
    Svg,
    AuthBlock,
  },
  mixins: [sendRequests],
  inject: {
    context: { from: ContextStateSymbol, default: {} },
    updateContext: { from: ContextUpdateSymbol, default: {} },
  },
  computed: {
    isAuth() {
      return this.context.isAuth ?? false;
    },
  },
  methods: {
    closeModal() {
      if (this.updateContext) {
        this.updateContext('isOpen', false);
        this.updateContext('step', 0);
        this.context.isAuth && this.fetchUserData();

        if (/\/register\/?$/.test(window.location.pathname)) {
          const newUrl = window.location.pathname.replace(/\/register\/?$/, '/');
          history.replaceState(null, '', newUrl);
        }
      }
    },
  },
}
</script>